import { ShapeRenderer } from "./ShapeRenderer";

function TriangleCountFigure() {
  return (
    <div className="w-full max-w-md rounded-lg border border-white/10 bg-slate-950/35 p-4">
      <svg viewBox="0 0 360 300" role="img" aria-label="Σχήμα με τρίγωνα για μέτρηση" className="mx-auto h-auto w-full max-w-sm">
        <g fill="none" stroke="rgb(165 243 252)" strokeLinecap="round" strokeLinejoin="round">
          <path d="M180 24 36 264h288Z" strokeWidth="5" />
          <path d="M180 24v240" strokeWidth="4" />
          <path d="M108 144h144" strokeWidth="4" />
          <path d="M72 204h216" strokeWidth="4" />
          <path d="M108 264 180 144l72 120" strokeWidth="4" />
          <path d="M72 264 180 84l108 180" strokeWidth="3" opacity="0.9" />
        </g>
        <g fill="rgb(8 47 73 / 0.22)">
          <path d="M180 24 108 144h144Z" />
          <path d="M108 144 72 204h216l-36-60Z" />
          <path d="M72 204 36 264h288l-36-60Z" />
        </g>
      </svg>
    </div>
  );
}

export function AttentionRenderer({ visualSpec }: { visualSpec: Record<string, unknown> }) {
  if (visualSpec.kind === "triangleCount") return <TriangleCountFigure />;

  const grid = (Array.isArray(visualSpec.grid) ? visualSpec.grid : []) as string[];
  const columns = Number(visualSpec.columns ?? 4);
  return (
    <div className="grid w-full max-w-md gap-2 rounded-lg border border-white/10 bg-slate-950/35 p-3" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
      {grid.map((shape, index) => (
        <div key={`${shape}-${index}`} className="flex min-h-14 items-center justify-center rounded-lg border border-white/10 bg-white/[0.045]">
          <ShapeRenderer spec={{ shape, color: index % 2 ? "blue" : "cyan", size: "sm" }} />
        </div>
      ))}
    </div>
  );
}
